import 'babel-polyfill';

import React from 'react';
import Footer from '../src/components/footer';
import Overlay from '../src/components/overlay';
import BottomBar from '../src/components/bottomBar';

module.exports = React.createClass({
  displayName: '_template',
  propTypes() {
    return {
      children: React.PropTypes.any
    };
  },
  getInitialState: function() {
    return { showedOverlay: '', displayType: 'phone' };
  },
  componentDidMount: function() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  componentWillUnmount: function() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  getDisplayType: function() {
    let displayType = 'large';
    if (window.matchMedia('(max-width: 768px)').matches) {
      displayType = 'phone';
    }
    if (
      window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches
    ) {
      displayType = 'medium';
    }
    return displayType;
  },
  resizeHandler: function() {
    this.setState({
      displayType: this.getDisplayType()
    });
  },
  setOverlay: function(overlay = '') {
    this.setState({
      showedOverlay: overlay
    });
  },
  render() {
    const { showedOverlay, displayType } = this.state;

    return (
      <div>
        {React.cloneElement(this.props.children, {
          displayType,
          showedOverlay,
          setOverlay: this.setOverlay
        })}

        <Footer setOverlay={this.setOverlay} />

        <Overlay setOverlay={this.setOverlay} showedOverlay={showedOverlay} />

        <BottomBar />
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./_template.jsx